import React, {Component} from "react";
import {connect} from "react-redux";
import {Menu} from "antd";
import {Link} from "react-router-dom";
import IntlMessages from "../../util/IntlMessages";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL
} from "../../constants/ThemeSetting";
      
import {version} from "util/config";


const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

class HorizontalNav extends Component {

  getNavStyleSubMenuClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-inside-submenu-popup-curve";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-below-submenu-popup-curve";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-above-submenu-popup-curve";
      default:
        return "gx-menu-horizontal";

    }
  };

  render() {
    const {pathname, navStyle} = this.props;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split('/')[1];
    return (

      <Menu
        defaultOpenKeys={[defaultOpenKeys]}
        selectedKeys={[selectedKeys]}
        mode="horizontal">
       {/* <Menu.Item className="item-menu-custom" >
            <img src="https://firebasestorage.googleapis.com/v0/b/cardiometabolic-sanfer.appspot.com/o/logo-2-best.png?alt=media" alt="Workplace" usemap="#workmap"/>
          </Menu.Item> */}

         <Menu.Item  className="item-menu-custom" >
         <a  className="item-menu-custom" href="https://cardiometabolicsanfer.com">Inicio</a>
          </Menu.Item>

        

          <Menu.Item className={this.getNavStyleSubMenuClass(navStyle)} >
            <Link className="item-menu-custom" to="/profile">Mi Perfil</Link>
          </Menu.Item>

          <Menu.Item  className={this.getNavStyleSubMenuClass(navStyle)} >
            <a  className="item-menu-custom" href="https://cardiometabolicsanfer.com/aviso">Términos</a>
          </Menu.Item>
         
   
          <Menu.Item  className={this.getNavStyleSubMenuClass(navStyle)} >
          <img src="https://firebasestorage.googleapis.com/v0/b/cardiometabolic-sanfer.appspot.com/o/logo-3-1-small.png?alt=media" alt="Workplace" usemap="#workmap"/>
          </Menu.Item>
          <Menu.Item  className={this.getNavStyleSubMenuClass(navStyle)} >
          <img src="https://firebasestorage.googleapis.com/v0/b/cardiometabolic-sanfer.appspot.com/o/logo-3-2-small.png?alt=media" alt="Workplace" usemap="#workmap"/>
          </Menu.Item>
         
     
      
      </Menu>
      

    );
  }
}

HorizontalNav.propTypes = {};
const mapStateToProps = ({settings}) => {
  const {themeType, navStyle, pathname, locale} = settings;
  return {themeType, navStyle, pathname, locale}
};
export default connect(mapStateToProps)(HorizontalNav);

